import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../../firebaseConfig';
import TopNavbar from '../../components/TopNavbar';
import SideNavbar from '../../components/SideNavbar';
import TestResults from '../../components/TestResults';
import AcademicResults from '../../components/AcademicResults';
import PersonalDetails from '../../components/PersonalDetails';
import { useAppSelector } from '../../redux/store';

const StudentMyProfile = () => {
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState("Personal Details");
    const [studentName, setStudentName] = useState("Loading...");
    const [companyName, setCompanyName] = useState("Loading...");
    const isCollapsed = useAppSelector(state => state.sidebar.isCollapsed);

    const progressSteps = [
        { label: "Personal Details", status: "completed" },
        { label: "Academic Results", status: "active" },
        { label: "Test Results", status: "pending" },
    ];

    // Fetch student and company details
    useEffect(() => {
        const fetchDetails = async () => {
            const user = auth.currentUser;
            if (user) {
                const idTokenResult = await user.getIdTokenResult();
                const claims = idTokenResult.claims;

                if (claims.role === 'student') {
                    if (claims.companyId && claims.leadUid) {
                        const leadDocRef = doc(db, `companies/${claims.companyId}/leads/${claims.leadUid}`);
                        const companyDocRef = doc(db, `companies/${claims.companyId}`);

                        const leadDoc = await getDoc(leadDocRef);
                        const companyDoc = await getDoc(companyDocRef);

                        if (leadDoc.exists()) {
                            setStudentName(leadDoc.data().name || "Unknown");
                        }

                        if (companyDoc.exists()) {
                            setCompanyName(companyDoc.data().name || "Unknown");
                        }
                    } else {
                        setStudentName("Unknown");
                        setCompanyName("Unknown");
                    }
                }
            } else {
                console.error("User is not authenticated");
                setStudentName("Unknown");
                setCompanyName("Unknown");
            }
        };

        fetchDetails();
    }, []);

    return (
        <div className="min-h-screen bg-gray-200">
            {/* <div className="fixed top-0 left-0 w-full z-10">
                <TopNavbar />
            </div> */}
            <div className="fixed top-16 left-0 h-full z-10">
                <SideNavbar />
            </div>
            <div className={`${isCollapsed ? 'ml-[70px]' : 'ml-[290px]'} mt-[109px] p-8 transition-all duration-300`}>
                <div className="bg-white min-h-screen p-6 rounded-3xl shadow-md w-full">
                    <div className="flex items-center gap-6 mb-6">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full "
                  style={{ background: 'linear-gradient(180deg, #00A6D9 10%, #3483BE 100%)' }}>
                  <img src={`${process.env.PUBLIC_URL}/images/desktop/sidebaricon/iconoir_profile-circle-white.svg`} alt="Preferences Icon" className="w-8 h-8" />
                </div>
                        <div className="flex flex-col">
                            <h3 className="font-montserrat text-2xl font-medium text-gray-900">My Profile</h3>
                           
                        </div>
                    </div>
                            <p className="font-montserrat text-xl ml-10 px-5 font-medium text-gray-900 mt-4 mb-5"> {studentName}</p>
                    <div className="relative flex w-full ml-12">
                        <div className="relative w-full max-w-3xl">
                            <div className="absolute top-2 left-[5%] right-[5%] border-t-2 border-dotted border-[#3483BE]" />
                            <div className="relative flex justify-between w-full">
                                {progressSteps.map((step, index) => (
                                    <div
                                        key={index}
                                        className="flex flex-col items-center cursor-pointer"
                                        onClick={() => setActiveStep(step.label)}
                                    >
                                        <div
                                            className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                                                step.label === activeStep
                                                    ? "border-[#3483BE] bg-white"
                                                    : index < progressSteps.findIndex(s => s.label === activeStep)
                                                    ? "border-[#3483BE] bg-[#3483BE]"
                                                    : "border-[#3483BE] bg-white"
                                            }`}
                                        >
                                            {step.label === activeStep && (
                                                <div className="w-3 h-3 rounded-full bg-gradient-to-t from-[#3483BE] to-[#02385E]"></div>
                                            )}
                                        </div>
                                        <span className="text-xs mt-2 text-center w-24 text-gray-600">{step.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="mt-5 ml-10 space-x-6 overflow-x-auto mb-6">
                        {activeStep === "Personal Details" && <div><PersonalDetails write={true} /></div>}
                        {activeStep === "Academic Results" && <div><AcademicResults write={true} /></div>}
                        {activeStep === "Test Results" && <div><TestResults write={true} /></div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentMyProfile;